import React from 'react';
import { Box } from '@material-ui/core';
const VerticalCentered = ({ children }) => (React.createElement(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100%' }, children));
export default VerticalCentered;
